exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-yellow{color:#fcdb01}.is-blue{color:#47c0e7}.is-red{color:#9f232b}.active{color:#f6f8f7}.app{display:flex;flex-direction:column;height:100vh}.grid-container{flex:1 0 auto;align-self:center}footer{position:relative;height:6px;width:100%;overflow:hidden;background-color:#bec0c2;flex-shrink:0}footer span{position:absolute;display:inline-block;height:100%;left:0;bottom:0}footer .footer-640{width:640px;background-color:#fcdb01}footer .footer-768{width:768px;background-color:#a2ce74}footer .footer-1024{width:1024px;background-color:#47c0e7}footer .footer-1200{width:1200px;background-color:#a9a9d1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41e1c0b4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 404
// module chunks = 0